import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpTestService } from 'app/services/http.service';

@Component({
  selector: 'app-prepaid-success-mobile',
  templateUrl: './prepaid-success-mobile.component.html',
  styleUrls: ['./prepaid-success-mobile.component.css']
})
export class PrepaidSuccessMobileComponent implements OnInit {

  public message: any;
  decodeMsg:any;
  array: any;

  consumerId: any;
  transactionNo: any;
  billdeskTransaction: any;
  desc: any;
  transactionDateTime: any;
  paymentGateway: any;
  meterNo: any;
  amount: any;
  remarkMessage: any;
  remark: any;

  successMsgSection: boolean = true;
  transSection: boolean = false;
  public serviceOn: boolean = false;

  transactionInfo: any;

  constructor(
    private route: ActivatedRoute,
    public httpService: HttpTestService
  ) { 

    // this.route.queryParams.subscribe(params => {
    //   this.message = params['msg'];

    //   this.decodeMsg = window.atob(this.message);
    //   this.array = this.decodeMsg.split("&"); 

    //   console.log(this.decodeMsg)
    //   console.log(this.array)

    //   this.consumerId = this.array[0].split("=")[1];
    //   this.transactionNo = this.array[1].split("=")[1];
    //   this.billdeskTransaction = this.array[2].split("=")[1];
    //   this.desc = this.array[3].split("=")[1];
    //   this.transactionDateTime  = this.array[4].split("=")[1];
    //   this.paymentGateway = this.array[5].split("=")[1];
    //   this.meterNo = this.array[6].split("=")[1];
    //   this.amount = this.array[7].split("=")[1];
    //   this.remarkMessage = this.array[8].split("=")[1];
    //   this.remark = this.array[9].split("=")[1];
    // });
    let url = "Y29uc2lkPTMxMDE0MTQmdHhubz0yMDIzMDYwOTAxNDA1NV8xMSZiZHR4bm89WEhENTExOTY4NjM2NzEmZGVzYz1QR1MxMDAwMS1TdWNjZXNzJnR4bmR0PTA5LTA2LTIwMjMgMTE6MTU6MzImcGF5Z3R5PUJJTExERVNLIFBBWU1FTlQmbWV0bm89Y3BzNjU2NSZhbXQ9MS4wMCZybXNnPVNVQ0NFU1MmcmVta3M9UGF5bWVudCBTdWNjZXNzZnVsIQ==";
    this.decodeMsg = atob(url);
    this.array = this.decodeMsg.split("&"); 

    this.consumerId = this.array[0].split("=")[1];
    this.transactionNo = this.array[1].split("=")[1];
    this.billdeskTransaction = this.array[2].split("=")[1];
    this.desc = this.array[3].split("=")[1];
    this.transactionDateTime  = this.array[4].split("=")[1];
    this.paymentGateway = this.array[5].split("=")[1];
    this.meterNo = this.array[6].split("=")[1];
    this.amount = this.array[7].split("=")[1];
    this.remarkMessage = this.array[8].split("=")[1];
    this.remark = this.array[9].split("=")[1];
  
  }

  ngOnInit() {
  }

  transactionDetails(){
    this.serviceOn = true;
    this.httpService.prepaidTransactionStatus(this.billdeskTransaction, this.meterNo).subscribe(
			response => {
				console.log("response ",response)
        if(response['status'] == 1 ){
					if(response['vendorData'].flag == "T"){
            this.successMsgSection = false;
            this.transSection = true;
            this.serviceOn = false;
						this.transactionInfo = response['vendorData'].data[0]
					}
				}
			}, error => {
			
			});
  }
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/prepaid-success-mobile/prepaid-success-mobile.component.ts